import { Grid, TextInput } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';
import { DateInput } from '@mantine/dates';
import { IconCalendarEvent } from '@tabler/icons-react';
import type { ProviderSettingsClinicalFormValues } from '@/schemas/practitioner.schema';

function formatLocalYmd(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function parseYmdToLocalDate(ymd: string): Date {
  const parts = ymd.split('-').map((p) => parseInt(p, 10));
  if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) {
    return new Date(ymd);
  }
  const [y, mo, d] = parts;
  return new Date(y, mo - 1, d);
}

export function ProviderCaqhSettingsFields({
  form,
}: {
  form: UseFormReturnType<ProviderSettingsClinicalFormValues>;
}): JSX.Element {
  return (
    <Grid>
      <Grid.Col span={{ base: 12, sm: 6 }}>
        <TextInput label="CAQH ID" placeholder="Enter CAQH ID" withAsterisk {...form.getInputProps('caqhId')} />
      </Grid.Col>
      <Grid.Col span={{ base: 12, sm: 6 }}>
        <DateInput
          label="Last CAQH Attestation"
          placeholder="Select a date"
          value={form.values.lastCaqhAttestation ? parseYmdToLocalDate(form.values.lastCaqhAttestation) : null}
          onChange={(v) => {
            form.setFieldValue(
              'lastCaqhAttestation',
              v != null ? (typeof v === 'string' ? v : formatLocalYmd(v)) : null,
            );
          }}
          leftSection={<IconCalendarEvent size={16} />}
          clearable
          error={form.errors.lastCaqhAttestation}
        />
      </Grid.Col>
      <Grid.Col span={{ base: 12, sm: 6 }}>
        <TextInput label="CAQH Username" placeholder="Enter username" withAsterisk {...form.getInputProps('caqhUsername')} />
      </Grid.Col>
      <Grid.Col span={{ base: 12, sm: 6 }}>
        <TextInput
          label="CAQH Password"
          placeholder="Enter password"
          type="password"
          withAsterisk
          {...form.getInputProps('caqhPassword')}
        />
      </Grid.Col>
    </Grid>
  );
}
